"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InvalidPipelinePayload = void 0;

var _BasePluginError2 = require("./BasePluginError");

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InvalidPipelinePayload =
/*#__PURE__*/
function (_BasePluginError) {
  _inherits(InvalidPipelinePayload, _BasePluginError);

  /* istanbul ignore next */
  function InvalidPipelinePayload() {
    var message = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : InvalidPipelinePayload._MESSAGE_;

    _classCallCheck(this, InvalidPipelinePayload);

    return _possibleConstructorReturn(this, _getPrototypeOf(InvalidPipelinePayload).call(this, message));
  }

  return InvalidPipelinePayload;
}(_BasePluginError2.BasePluginError);

exports.InvalidPipelinePayload = InvalidPipelinePayload;

_defineProperty(InvalidPipelinePayload, "_MESSAGE_", 'arg `middlewares` must be an array of middlewares');
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9saWIvRXhjZXB0aW9ucy9JbnZhbGlkUGlwZWxpbmVQYXlsb2Fkcy50cyJdLCJuYW1lcyI6WyJJbnZhbGlkUGlwZWxpbmVQYXlsb2FkIiwibWVzc2FnZSIsIl9NRVNTQUdFXyIsIkJhc2VQbHVnaW5FcnJvciJdLCJtYXBwaW5ncyI6Ijs7Ozs7OztBQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7SUFFYUEsc0I7Ozs7O0FBSVg7QUFDQSxvQ0FBZ0U7QUFBQSxRQUFwREMsT0FBb0QsdUVBQWxDRCxzQkFBc0IsQ0FBQ0UsU0FBVzs7QUFBQTs7QUFBQSwrRkFDeERELE9BRHdEO0FBRS9EOzs7RUFQeUNFLGlDOzs7O2dCQUEvQkgsc0IsZUFFVCxtRCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IEJhc2VQbHVnaW5FcnJvciB9IGZyb20gJy4vQmFzZVBsdWdpbkVycm9yJ1xuXG5leHBvcnQgY2xhc3MgSW52YWxpZFBpcGVsaW5lUGF5bG9hZCBleHRlbmRzIEJhc2VQbHVnaW5FcnJvciB7XG4gIHByb3RlY3RlZCBzdGF0aWMgcmVhZG9ubHkgX01FU1NBR0VfOiBzdHJpbmcgPVxuICAgICdhcmcgYG1pZGRsZXdhcmVzYCBtdXN0IGJlIGFuIGFycmF5IG9mIG1pZGRsZXdhcmVzJ1xuXG4gIC8qIGlzdGFuYnVsIGlnbm9yZSBuZXh0ICovXG4gIGNvbnN0cnVjdG9yKG1lc3NhZ2U6IHN0cmluZyA9IEludmFsaWRQaXBlbGluZVBheWxvYWQuX01FU1NBR0VfKSB7XG4gICAgc3VwZXIobWVzc2FnZSlcbiAgfVxufVxuIl19